var exports = {
  "l": "AttachmentMosaic.module__mosaicContainerWrapper___RjZ0UF",
  "Y": "AttachmentMosaic.module__mosaicContainer___RjZ0UF",
};

module.exports = exports;
